import React, { useMemo } from "react";
import Icon from "./Icon";
import { t } from "../../lib/theme";
import { cdn } from "../../lib/cdn";

const Avatar = ({
  seed = "x",
  size = 48,
  online,
  badge,
  src,
  onError,
  onClick,
  style,
}) => {
  // Pick a CDN preset based on rendered size. ≥120 → card; otherwise thumb.
  const transformedSrc = useMemo(
    () => cdn(src, size >= 120 ? "card" : "thumb"),
    [src, size]
  );
  const hash = useMemo(() => {
    let h = 7;
    for (const c of String(seed)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
    return h;
  }, [seed]);
  const h1 = hash % 360;
  const h2 = (hash >> 6) % 360;
  const initial =
    String(seed).replace(/[^A-Za-z0-9]/g, "")[0]?.toUpperCase() || "✦";

  return (
    <div
      onClick={onClick}
      style={{
        position: "relative",
        flexShrink: 0,
        width: size,
        height: size,
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {src ? (
        <img
          src={transformedSrc}
          alt=""
          loading="lazy"
          decoding="async"
          onError={onError}
          style={{
            width: size,
            height: size,
            borderRadius: 999,
            objectFit: "cover",
            display: "block",
            boxShadow:
              "inset 0 -8px 20px rgba(0,0,0,0.08), inset 0 8px 20px rgba(255,255,255,0.12)",
          }}
        />
      ) : (
        <div
          style={{
            width: size,
            height: size,
            borderRadius: 999,
            background: `linear-gradient(135deg, oklch(0.78 0.16 ${h1}) 0%, oklch(0.72 0.18 ${h2}) 100%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#FFFFFF",
            fontSize: size * 0.42,
            fontWeight: 700,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            boxShadow:
              "inset 0 -8px 20px rgba(0,0,0,0.12), inset 0 8px 20px rgba(255,255,255,0.18)",
          }}
        >
          {initial}
        </div>
      )}
      {online && (
        <div
          style={{
            position: "absolute",
            bottom: 1,
            right: 1,
            width: Math.max(8, size * 0.26),
            height: Math.max(8, size * 0.26),
            borderRadius: 999,
            background: t.success,
            border: `2px solid ${t.surface}`,
          }}
        />
      )}
      {badge && (
        <div
          style={{
            position: "absolute",
            top: -2,
            right: -2,
            width: 18,
            height: 18,
            borderRadius: 999,
            background: t.goldGrad,
            border: `2px solid ${t.surface}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#5A3D00",
          }}
        >
          <Icon name="crown" size={10} sw={2.4} />
        </div>
      )}
    </div>
  );
};

export default Avatar;
